<template>
 <v-container fluid>
  <v-layout row>
    <v-flex xs12>
      <form @submit.prevent="onCreateContent">
        <v-layout row wrap>
          <v-flex xs12 sm9 pr-3 >
            <div id="videoHolder" v-if="mode=='video'">
            <div style="margin-left:15px; font-size:16px">
            <h2>Video</h2>
            <p>Video content must be an h264 encoded MP4.
             We cannot accept links to youtube, vimeo etc.</p>
            <p>The screen resolution is 960x576px. 
            All content will be resized to fit the screen. 
            <br>In default mode standard 16x9 content will lose 32 pixels from each side.<br>
            <br>Once your video has been uploaded you will be able to preview your video and choose how it will fit on the screen.</p>
            <p><b>Looping videos:-</b> If you video is designed to be a continuous loop please check the looping icon</p>
            <p>All details must be submitted before your video can be uploaded.</p>
            </div>

              <div v-show="!videoUrl && false" class="aspect"><h2>{{videoText}}</h2></div>
             
              <v-btn raised class="secondary" @click="mode='message'">Cancel</v-btn>
              <v-btn v-if="enableVideoUpload" raised class="primary" @click="onPickVideo">Select Video</v-btn>
              <span style="font-size:16px" v-show="!videoUrl " ><b>{{videoDetails}}</b></span>
              <v-btn v-if="videoDetails" raised class="primary" @click="addVideo">Upload Video</v-btn>
            
            </div>
            <div id="webHolder" v-if="mode=='web'">
              <h5 v-if="!webURL" class="primary--text">Submit URL</h5>
              <vue-friendly-iframe v-if="webURL" :src="webURL" id="webFrame"></vue-friendly-iframe>
              <v-text-field
                name="URL"
                label="URL"
                id="description"
                v-model="webURLInput">
              </v-text-field>
              <img v-if="false" class="ledOverlay" src="../../assets/images/screenOverlay.png" width="100%">
              <v-btn raised class="primary" @click="onPickUrl">Select URL</v-btn>
              <v-btn raised class="secondary" @click="mode='message'">Cancel</v-btn>
            </div>
            <div v-if="mode=='title'">
              <h5 class="primary--text">Title Card</h5>
              <div id="cardHolder">
                <div class="cTitle">{{contentInfo.title}}</div>
                <div class="cSubtitle">{{contentInfo.subtitle}}</div>
                <div class="cBody">{{contentInfo.body}}</div>
                <div class="cFooter">{{contentInfo.footer}}</div>
              </div>
              <v-text-field
                name="title"
                label="Title"
                v-model="contentInfo.title"
                id="title"
                :rules="titleRules"
                required>
              </v-text-field>
              <v-text-field
                name="subtitle"
                label="Subtitle"
                v-model="contentInfo.subtitle"
                id="subtitle">
              </v-text-field>
              <v-text-field
                name="body"
                label="Body"
                v-model="contentInfo.body"
                id="body">
              </v-text-field>
              <v-text-field
                name="footer"
                label="Footer"
                v-model="contentInfo.footer"
                id="footer">
              </v-text-field>
              <v-btn raised class="secondary" @click="mode='message'">Cancel</v-btn>
            </div>
            <div v-if="mode=='message'">
              <h2 >Participate</h2>
              <p>The Loop takes submissions for content throughout the year. It’s open to artists, curators, and community-members and organisations who work with creative screen-based media.<br>The Loop does not accept advertising or promotional material.<br>To submit content for consideration, upload a file here.</p>
              <v-btn @click="setType('video')" class="primary">Submit Video</v-btn>
              <v-btn @click="setType('web')" class="primary">Submit Web Content</v-btn>
              <v-btn v-if="isCurator" @click="setType('title')" class="primary">Create Title Card</v-btn>
            </div>
            <v-container v-if="mode!='message'" pl-3 pr-1 >
          <v-layout fluid >
            <v-flex xs12 v-if="uploading()">
              <v-progress-linear v-model="progress" ></v-progress-linear>
            </v-flex>
          </v-layout>
          <v-layout text-xs-right>
            <v-flex xs1 text-xs-left>
              <span v-if="uploading()">{{progressText}}</span>
            </v-flex>
           </v-layout>
           </v-container>
        </v-flex>
        <v-flex xs12 sm3 v-if="mode!='title' && mode!='message'" >
          <div id="imageHolder" v-if="mode!='title'  && false">
            <div v-show="!imageUrl" class="aspect"><h5>Poster Image</h5></div>
            <img v-show="imageUrl" :src="imageUrl" width="100%">
            <v-btn raised class="primary" :disabled="uploading()" @click="onPickFile">Select Image</v-btn>
          </div>
          <v-layout row>
            <v-flex xs12>
              <v-text-field
                name="title"
                label="Title"
                v-model="contentInfo.title"
                id="title"
                :rules="titleRules"
                required>
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12>
              <v-text-field
                name="author"
                label="Artist"
                v-model="contentInfo.author"
                id="author"
                :rules="notEmpty"
                required>
              </v-text-field>
               
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-textarea
                    name="description"
                    label="Description"
                    id="description"
                    v-model="contentInfo.description"
                    required
                ></v-textarea>
              </v-flex>
            </v-layout row>
            <v-layout row>
              <v-flex xs12>
                <v-combobox
                  v-model="contentInfo.keywords"
                  :items="keywords"
                  label="Keywords - select from list or add your own."
                  multiple
                  hide-selected
                  deletable-chips
                  chips>
                </v-combobox>
              <v-flex xs12>
              </v-flex>
                <v-checkbox  :label="`Add title to start of content`"
                    v-model="contentInfo.addTitle"
                ></v-checkbox>
                <v-btn class="primary" :disabled="!formIsValid || uploading()" type="submit">Create Entry</v-btn>
            
                <app-view-content-details-dialog v-if="false" :videoUrl="videoUrl" :imageUrl="imageUrl" :content="contentInfo"></app-view-content-details-dialog>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
         
        
         
        <v-layout row>
          <v-flex xs12 sm6 offset-sm3>
          
         
          <input type="file" style="display:none;" ref="fileInput" 
          accept="image/*"
          @change="onFilePicked"
          ></input>
          <input type="file" style="display:none;" ref="videoInput" 
          accept="video/mp4"
          @change="onVideoPicked"
          ></input>
           
          </v-flex>
        </v-layout>
        
      </form>
      
      
    </v-flex>
  </v-layout>
 </v-container>
</template>

<script>
import VueFriendlyIframe from 'vue-friendly-iframe';
import Checkbox from 'vuetify'
import html2canvas from 'html2canvas'

  export default {
    //Vue.component('vue-friendly-iframe', VueFriendlyIframe);
    components: { VueFriendlyIframe, Checkbox },
    data () {
      return {
        mode:"message",
        enableVideoUpload:false,
        uploadStarted:false,
        videoText:'[ MP4 files Only - NB Large Files may not Preview ]',
        videoDetails:"",
        valid: true,
        imageUrl: '',
        videoUrl: '',
        webURL:'',
        webURLInput:'',
        date: new Date(),
        time: new Date(),
        contentInfo:{
          title: '',
          author: '',
          image: '',
          video: '',
          videoSize:'',
          description: '',
          duration: '',
          type: 'video',
          addTitle:false,
          keywords:[],
          date: new Date(),
          scaleMode:'none',
          mode:"created",
        },
        
        keywords: [
          'UTAS', 
          'Student',
          'Wide Angle',
          'The Loop',
          'Test'
        ],
        notEmpty: [
          (v) => !!v || 'can\'t be empty'
        ],
        titleRules: [
          (v) => !!v || 'Title is required',
          (v) => v && v.length >= 2 || 'Title is too short'
        ]
      }
    },
    computed: {
      newContent (){
        return this.$store.getters.newContent
      },
      progress () {
        return this.$store.getters.progress
      },
      progressText () {
        var pct=(Math.floor(this.progress*100)*.01+"").substr(0,5)
         if(pct.length==1){
          pct+=".00"
        }
        if(pct.length==2){
          pct+=".00"
        }
        if(pct.length==3){
          pct+="0"
        }
        if(pct.length==4 && this.progress>10){
          pct+="0"
        }
        return pct+"%"
      },
      formIsValid () {
        return this.contentInfo.title !== '' &&
        (this.contentInfo.author !== '' || this.mode=='title') &&
        (this.imageUrl !== '' || this.mode!='web') &&
        //(this.contentInfo.video !== '' || this.mode!=='video' ) &&
        (this.webUrl !== '' || this.mode!=='web' ) &&
        (this.contentInfo.description !== '' || this.mode=='title')
      },
      fullDateTime () {
        const date = new Date(this.date)
        if (typeof this.time === 'string') {
          const hours = this.time.match(/^(\d+)/)[1]
          const minutes = this.time.match(/:(\d+)/)[1]
          date.setHours(hours)
          date.setMinutes(minutes)
        } else {
          date.setHours(this.time.getHours())
          date.setMinutes(this.time.getMinutes())
        }
        return date
      },
      userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      },
      isCurator(){ 
            return this.$store.getters.userCurator;
      }
    },
    watch:{
      newContent(value){
        console.log("NEW CONTENT",value)
        this.contentInfo.id=value.id
        if(value.type=="video"){
          this.enableVideoUpload=true;
        }
        
      }
    },
    methods: {
      setType(type){
        this.mode=type;
        this.contentInfo.type=type;
      },
      getScreenGrab(){
        
        
        html2canvas(document.querySelector("#webFrame").querySelector("body")).then(canvas => {
            document.body.appendChild(canvas)
        });

        canvas = document.getElementById("c");
        var storageRef = firebase.storage().ref();
        var mountainsRef = storageRef.child('mountains.jpg');
        var image = new Image();
        image.src = canvas.toDataURL("image/png");
        var uploadTask = storageRef.child('images/' + "apple").put(image);
        uploadTask.on('state_changed', function(snapshot){
            // Observe state change events such as progress, pause, and resume
            // See below for more detail
        }, function(error) {
            // Handle unsuccessful uploads
        }, function() {
            // Handle successful uploads on complete
            // For instance, get the download URL: https://firebasestorage.googleapis.com/...
            var downloadURL = uploadTask.snapshot.downloadURL;
        });
        
    },
      uploading () {
        if(!this.$store.getters.uploading && this.uploadStarted){
          this.uploadStarted=false;
          this.$router.push('/profile')
        }else if(this.$store.getters.uploading){
          this.uploadStarted=true;
        }
       return this.$store.getters.uploading
     },
      
      onCreateContent () {
        console.log("CREATE CONTENT");
        if (!this.formIsValid) {
          return
        }
        if (!this.contentInfo.image && this.mode!="title") {
          //return
        }
        if (!this.contentInfo.video && this.mode=="video") {
         // return
        }
        if (!this.contentInfo.web && this.mode=="web") {
          return
        }
        
        this.$store.dispatch('createContentInfo', this.contentInfo)
      },
      onPickFile () {
        this.$refs.fileInput.click()
      },
      onPickVideo () {
        this.contentInfo.web="";
        this.$refs.videoInput.click()
      },
      addVideo(){
        this.$store.dispatch('replaceVideo', this.contentInfo)
       
      },
      onPickUrl(){
        this.contentInfo.web=this.webURLInput;
        this.contentInfo.video="";
        this.webURL=this.webURLInput;
      },
      onVideoPicked (event) {
        var self=this;
        this.videoText="loading preview "
        const files = event.target.files
        
        let filename = files[0].name;
        this.videoDetails="file:"+filename +" size:"+Math.round(files[0].size/1024/1024)+"MB";
         console.log(files[0]);
         
        if (filename.lastIndexOf('.') <= 0) {
          return alert('Please add a valid file')
        }
        var fileReader = new FileReader()
        fileReader.addEventListener('load', (data) => {
          console.log("LOADING",fileReader)
          console.log("LOADING2",data)
          
        })
        fileReader.addEventListener('progress', (data) => {
          console.log("progress",data)
          this.videoText="loading preview "+data.loaded;
          
        })
        fileReader.addEventListener('loadend', (data) => {
          console.log("LOADED",fileReader,data)
          this.videoUrl = fileReader.result
        })
        
          this.videoText="File too large to preview please continue with submission or upload a smaller file"
          this.contentInfo.video = files[0]
        
       
      },
      onFilePicked (event) {
        const files = event.target.files
        let filename = files[0].name
        if (filename.lastIndexOf('.') <= 0) {
          return alert('Please add a valid file')
        }
        const fileReader = new FileReader()
        fileReader.addEventListener('load', () => {
          this.imageUrl = fileReader.result
        })
        fileReader.readAsDataURL(files[0])
        this.contentInfo.image = files[0]
      }
    }
  }
</script>
<style>
iframe{
  width:100%;
  height:100%;
}
#webFrame{
  width: 960px;
    height: 576px;
    max-width:100%;
}
#cardHolder{
  width: 640px;
  height: 384px;
  background-color:#000;
  color:#fff;
  position:relative;
}
#cardHolder .cTitle{
  padding-top: 10%;
  position: relative;
  width: 100%;
  text-align: center;
  font-size: 200%;
}
#cardHolder .cSubtitle{
  position:relative;
  width:100%;
  text-align:center;
  font-size: 150%;
}
#cardHolder .cBody{
  padding-top: 10%;
  position:relative;
  width:100%;
  text-align:center;
  font-size: 100%;
}
#cardHolder .cFooter{
  bottom:10%;
  position:absolute;
  width:100%;
  text-align:center;
  font-size: 80%;
}

#videoHolder{
  position:relative;
  padding:5px;
  margin:auto; 
}
#imageHolder{
  padding:5px;
  margin:auto;
}
.placeHolder{
  width:100%;
  margin:auto;
}
.ledOverlay{
  position: absolute;
    top: 10px;
    width: 97%;
    pointer-events: none;
}
.aspect {
  background-color:#333;
  width: 100%;
  color:#777;
  text-align:center;
  padding-top:20%;
}
.videoBase{
  width: 100%;
  position:absolute;
  padding-left:10px;
  bottom:10%;
  color:#777;
  text-align:left;
}
.aspect::before {
    content: "";
    float: left;
    padding-bottom: 36.25%;
  }
  .aspect::after {
    content: "";
    display: table;
    clear: both;
  }
.input-group__details{
    min-height:20px;
  }
  .input-group__details{
    min-height:10px;
  }

  

</style>


// WEBPACK FOOTER //
// src/components/Content/UploadNew.vue